/**
 * Sistema de logging centralizado
 * Respeta NODE_ENV y proporciona diferentes niveles de logging
 */

const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
  NONE: 4
};

// Determinar nivel de log basado en NODE_ENV
const getLogLevel = () => {
  if (process.env.NODE_ENV === 'production') {
    return LOG_LEVELS.ERROR; // Solo errores en producción
  }
  return LOG_LEVELS.DEBUG; // Todo en desarrollo
};

const currentLogLevel = getLogLevel();

/**
 * Logger principal
 */
const logger = {
  /**
   * Log de debug (solo en desarrollo)
   */
  debug: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.DEBUG) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Log de información (solo en desarrollo)
   */
  info: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.INFO) {
      console.info('[INFO]', ...args);
    }
  },

  /**
   * Log de advertencia (solo en desarrollo)
   */
  warn: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.WARN) {
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Log de error (siempre visible, pero más detallado en desarrollo)
   */
  error: (...args) => {
    if (currentLogLevel <= LOG_LEVELS.ERROR) {
      console.error('[ERROR]', ...args);
    }
    // En producción, podría enviarse a un servicio de monitoreo
    if (process.env.NODE_ENV === 'production') {
      // TODO: Integrar con servicio de monitoreo (Sentry, LogRocket, etc.)
      // Example: Sentry.captureException(new Error(args.join(' ')));
    }
  },

  /**
   * Log de grupo (solo en desarrollo)
   */
  group: (label) => {
    if (currentLogLevel <= LOG_LEVELS.DEBUG) {
      console.group(label);
    }
  },

  /**
   * Cerrar grupo (solo en desarrollo)
   */
  groupEnd: () => {
    if (currentLogLevel <= LOG_LEVELS.DEBUG) {
      console.groupEnd();
    }
  }
};

export default logger;
